import { Navigate, useParams } from 'react-router';
import { Box } from '@mantine/core';
import PageWithSidebar from 'src/UI/page-nav/PageWithSidebar';
import { CompanyTabs } from './types';
import FundsListPage from 'src/company/funds/components/FundsListPage';
import ProvidersListPage from 'src/company/providers/components/ProvidersListPage';
import AppendicesListPage from 'src/company/appendices/components/AppendicesListPage';
import CompanyFilesPage from 'src/company/documents/components/CompanyFilesPage';
import CompanyMemoriesPage from 'src/company/memories/CompanyMemoriesPage';
import ConnectedAssetsPage from 'src/connected-assets/ConnectedAssetsPage';
import { useFlags } from 'src/feature-flags/FlagsHook';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';

export default function CompanyPage() {
  const { tab } = useParams<{ tab: string }>();
  const { flagEnabledBulkValControlCentre, flagEnabledCompanyDocuments } = useFlags();
  const { isSystemAdmin } = useCurrentUser();

  const COMPANY_LINKS = [
    {
      label: 'Funds',
      href: '/company/funds',
    },
    {
      label: 'Provider sources',
      href: '/company/providers',
    },
  ];

  if (flagEnabledBulkValControlCentre && isSystemAdmin) {
    COMPANY_LINKS.push({
      label: 'Connected products',
      href: '/company/connected-assets',
    });
  }

  COMPANY_LINKS.push({
    label: 'Appendices',
    href: '/company/appendices',
  });

  if (flagEnabledCompanyDocuments) {
    COMPANY_LINKS.push({
      label: 'Documents',
      href: '/company/documents',
    });
  }

  if (isSystemAdmin) {
    COMPANY_LINKS.push({
      label: 'Company memories',
      href: '/company/memories',
    });
  }

  if (!tab) {
    return <Navigate to="/company/funds" replace />;
  }

  const renderContent = () => {
    switch (tab) {
      case CompanyTabs.funds:
        return <FundsListPage />;
      case CompanyTabs.providers:
        return <ProvidersListPage />;
      case CompanyTabs.connectedAssets:
        if (!flagEnabledBulkValControlCentre || !isSystemAdmin) {
          return <Navigate to="/company/funds" replace />;
        }
        return <ConnectedAssetsPage />;
      case CompanyTabs.appendices:
        return <AppendicesListPage />;
      case CompanyTabs.documents:
        if (!flagEnabledCompanyDocuments) {
          return <Navigate to="/company/funds" replace />;
        }
        return <CompanyFilesPage />;
      case CompanyTabs.memories:
        if (!isSystemAdmin) {
          return <Navigate to="/company/funds" replace />;
        }
        return <CompanyMemoriesPage />;
      default:
        return <Navigate to="/company/funds" replace />;
    }
  };

  return (
    <Box pt="xxl">
      <PageWithSidebar links={COMPANY_LINKS} activeUrl={`/company/${tab}`}>
        {renderContent()}
      </PageWithSidebar>
    </Box>
  );
}
